export const cloudinaryConfig = {
  cloudName: "pgahq", // Your actual cloud name
  uploadPreset: "hole-in-one", // Your upload preset name
  apiUrl: "https://api.cloudinary.com/v1_1/pgahq/image/upload",

  // Default transformations
  defaultTransformations: {
    quality: "auto",
    format: "auto",
  },
};
